<template>
	<app>
		<div class="company-list">
			<div class="title">选择保险公司</div>
			<ul class="flex-between flex-wrap">
				<li class="flex-center-cross" v-for="(item, i) in insuranceList" :key="i" @click="navigateTo('/insurance_apply', {companyId: item.id}, 'replace')">
					<img class="logo" :src="item.image">
				</li>
			</ul>
		</div>
	</app>
</template>

<script>
	export default {
		props: {
			projectId: String,
			type: String
		},
		
		data() {
			return {
				insuranceList: []
			}
		},
		
		mounted() {
			this.request({
				url: '/bxgs/list',
				data: {
					type_id: this.type
				},
				success: data => {
					this.insuranceList = data;
				}
			});
		}
	}
</script>

<style lang="stylus" scoped>
	.company-list {
		border-radius: .2rem;
		padding: .24rem;
		margin: .24rem;
		background: #fff;
		
		.title {
			position: relative;
			padding-left: .2rem;
			line-height: .52rem;
			font-size: .36rem;
			font-weight: bold;
			color: #1F1F1F;
			
			elder({
				font-size: .48rem
			})
			
			&:before {
				content: '';
				position: absolute;
				left: 0;
				top: .1rem;
				width: .06rem;
				height: .32rem;
				background: #0366F1;
				
				elder({
					top: .06rem,
					height: .4rem
				})
			}
		}
		
		ul {
			li {
				box-sizing: border-box;
				width: 3.16rem;
				height: 1.2rem;
				padding: 0 .1rem;
				margin-top: .2rem;
				background: linear-gradient(90deg, rgba(243,251,254,0), #F3FBFE);
			}
		}
	}
</style>